// Port of api/fuel/app/classes/insights/collection/counts.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Game from 'offline/model/game'

export default Segment.extend({
    name: 'counts',
    insight: false,
    detail: false,
    run: function(type, owner, userIndex, detail, filter, vars) {

        if (!owner.get_count_collection()) return {}

        var counts = {}

        for (var i = 1; i <= 6; i++) {
            counts[i] = {
                o: 0,
                r: 0,
                b: 0
            }
        }

        var collectionIndex = this._data.base

        var gameCounts = Game.filter({
            arrayed: true,
            select: {
                plain: [
                    'game_players_min',
                    'game_players_max',
                    'game_players_community'
                ]
            },
            where: [
                ['game_id', 'in', collectionIndex.filter(function(v, i, a) { return a.indexOf(v) === i })]
            ]
        })

        for (var gi = 0; gi < gameCounts.length; gi++) {
            var game = gameCounts[gi]

            var pc = null
            try { pc = JSON.parse(game.game_players_community) } catch (e) { pc = null }
            if (!pc) pc = {}

            for (var j = 1; j <= 6; j++) {

                if (j >= game.game_players_min && j <= game.game_players_max) {
                    counts[j].o++
                }

                if (pc[j] !== undefined) {

                    if (pc[j].b + pc[j].r > pc[j].n) {
                        counts[j].r++
                    }

                    if (pc[j].b > pc[j].r + pc[j].n) {
                        counts[j].b++
                    }

                }

            }
        }

        return {
            counts: counts
        }

    }
})
